var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Generated by `npm run icon`, don't modify this file
import React from 'react';
import Base from './_base';
const QuestionCircle = props => {
    const { className = null } = props, other = __rest(props, ["className"]);
    return (<Base viewBox="0 0 16 16" className={`cuk2-icon-question_circle ${className}`} {...other}>
      <g>
        <path d="M8 0a8 8 0 110 16A8 8 0 018 0zm0 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zm-.125 9.37a.873.873 0 110 1.745.873.873 0 010-1.746zm0-7.313c.78 0 1.515.268 2.074.757.585.512.909 1.204.907 1.944 0 1.088-.715 2.064-1.816 2.488a.684.684 0 00-.405.43l-.022.096-.007.102v.4c0 .112-.06.212-.169.27l-.07.03-.072.01h-.844a.305.305 0 01-.271-.168l-.03-.071-.01-.072v-.377A2.136 2.136 0 018.347 7.45l.17-.074c.536-.206.877-.647.877-1.12 0-.673-.676-1.235-1.518-1.235-.742 0-1.361.438-1.491 1.003l-.02.114-.006.119v.133c0 .112-.06.213-.169.272l-.07.03-.072.009h-.844a.305.305 0 01-.271-.168l-.03-.071-.01-.072v-.133c0-.74.325-1.432.91-1.944a3.142 3.142 0 012.073-.757z" fillRule="evenodd"/>
      </g>
    </Base>);
};
export default QuestionCircle;
